import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "4",
  viewBox: "0 0 13 4",
  fill: "none"
}
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'zoomOutIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#B7B7B7",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M1.25 0H11.75C11.75 0 12.5 0 12.5 0.857143V3.14286C12.5 3.14286 12.5 4 11.75 4H1.25C1.25 4 0.5 4 0.5 3.14286V0.857143C0.5 0.857143 0.5 0 1.25 0Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})